<template>
  <!-- Bed Web Start -->
  <div class="product-bed-web">
    <div class="web">
      <div class="app__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('bed.web.title')}}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('bed.web.sub-title')}}</span>
          <span class="sub-title__exp">{{$t('bed.web.sub-title-exp')}}</span>
        </div>
      </div>
      <div class="web__image">
        <div class="web__image__item" data-aos="fade-up" :data-aos-duration="duration">
          <!-- language check -->
          <template v-if="$i18n.locale() === 'ko'">
            <!-- ** lang KO Start ** -->
            <img src="../../assets/img/img_bed_web_ko.png" alt="web"/>
            <span class="web__image__text--ko">{{$t('bed.web.image1')}}</span>
            <!-- ** lang KO End ** -->
          </template>
          <template v-else>
            <!-- ** lang EN Start ** -->
            <img src="../../assets/img/img_bed_web_en.png" alt="web"/>
            <span>{{$t('bed.web.image1')}}</span>
            <!-- ** lang EN Start ** -->
          </template>
        </div>
      </div>
    </div>
  </div>
  <!-- Bed Web End -->
</template>

<script>
import { FadeUpMixin } from '../mixins/FadeUp';

export default {
  name: 'BedWeb',
  data() {
    return {
    };
  },
  mixins: [FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/constant';
  @import '../../assets/scss/mixins';

  /* ------------------
    :: Product Bed Web CSS
    ------------------ */
  .product-bed-web {
    padding: 0 40px 102px;
    @include flexbox;
    @include flex-direction(column);
    @include align-items(center);

    .web {
      width: 100%;
      max-width: 1518px;
      @include flexbox;
      @include flex-direction(column);
      flex-shrink: 0;
    }
  }

  .web__image {
    @include inline-flex;
    @include justify-content(center);
    flex-shrink: 0;
    width: 100%;
    margin-top: 0;
    &__item {
      position: relative;
      & > img {
        max-width: 1200px;
        width: 100%;
      }
      & > span {
        position: absolute;
        left: 0;
        right: auto;
        top: 8%;
        bottom: auto;

        color: $color-black;
        font-size: 16px;

        writing-mode: vertical-lr;
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);

        &.web__image__text--ko {
          left: -45px;
          top: 27%;
          margin-left: 10px;

          writing-mode: inherit;
          -webkit-transform: rotate(-90deg);
          -ms-transform: rotate(-90deg);
          transform: rotate(-90deg);
        }
      }
    }
  }

  @media (min-width: 576px) {
    .web__image {
      &__item {
        & > span.web__image__text--ko {
          left: -40px;
          top: 20%;
        }
      }
    }
  }

  @media (min-width: 648px) {
    .web__image {
      margin-top: 58px;
    }
  }
  @media (min-width: 768px) {
    .web__image {
      &__item {
        & > span {
          left: 4%;
          &.web__image__text--ko {
            left: 0;
          }
        }
      }
    }
  }
</style>
